import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
    IonCard,
} from '@ionic/react';
import Header from './Header';
import Footer from './Footer';

const Faq: React.FC = () => {
    return (
        <>
            <IonContent>
                <Header />
                <IonCard className='privacy-policy-section'>
                    <h1 className='text-center font-50'>Frequently Asked Questions (FAQ)</h1>

                    <div className='mt-5'>
                        <h2>1. What is MamasGuidance.com?</h2>
                        <p><strong>MamasGuidance.com</strong> is an educational platform that provides engaging and age-appropriate worksheets, activities, and learning resources for children from Nursery to Class 2. We also support Olympiad exam preparation for Class 1 and 2.</p>

                        <h2>2. Who is this platform for?</h2>
                        <p>This website is ideal for young learners (ages 3 to 7), parents, teachers, and homeschoolers who are looking for structured learning material across subjects like English, Math, EVS, and Logical Reasoning.</p>

                        <h2>3. Are the worksheets free to use?</h2>
                        <p>Yes, most of our worksheets are freely accessible.</p>

                        <h2>4. Do you cover Olympiad preparation?</h2>
                        <p>Absolutely! We provide specially designed worksheets and quiz formats for Olympiad subjects like IMO (Maths), NSO (Science), IEO (English), and more for Class 1 and Class 2 students.</p>

                        <h2>5. How can I download the worksheets?</h2>
                        <p>You can&apos;t download the worksheets right now. But you can access all the worksheets through our website.</p>

                        <h2>6. Can I access content without registering?</h2>
                        <p>Yes, all resources are open access.</p>

                        <h2>7. Do you update the content regularly?</h2>
                        <p>Yes! We are constantly adding new worksheets, quizzes, and topics to support your child’s learning journey.</p>

                        <h2>8. How can I contact the MamasGuidance team?</h2>
                        <p>You can reach us through our <a href="/contact-us">Contact Us</a> page or email us at <a href="mailto:support@mamasguidance.com">support@mamasguidance.com</a>.</p>

                        <h2>9. Is your content aligned with school curriculum?</h2>
                        <p>Yes, all content is thoughtfully aligned with early learning curriculums like CBSE, ICSE, and other state boards.</p>

                        <h2>10. Can I request a specific type of worksheet?</h2>
                        <p>Definitely! We welcome suggestions. Visit our contact page to submit requests for new worksheet topics or activity types.</p>
                    </div>
                </IonCard>
                <Footer />
            </IonContent>
        </>
    );
};

export default Faq;